import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { ScrollToTop } from './components/ScrollToTop';
import { AnnouncementBanner } from './components/AnnouncementBanner';
import { LandingPage } from './pages/LandingPage';
import { ContextEngineeringPage } from './pages/ContextEngineeringPage';
import { HowItWorksPage } from './pages/HowItWorksPage';
import { ArchitecturePage } from './pages/ArchitecturePage';
import { AboutPage } from './pages/AboutPage';
import { PricingPage } from './pages/PricingPage';
import { ContactPage } from './pages/ContactPage';
import { PrivacyPage } from './pages/PrivacyPage';
import { TermsPage } from './pages/TermsPage';
import { BlogPage } from './pages/BlogPage';
import { BlogArticleDetail } from './pages/BlogArticleDetail';
import { LoginPage } from './pages/LoginPage';
import { AgentDriftPage } from './pages/AgentDriftPage';
import { SupportPage } from './pages/SupportPage';
export function App() {
  return <BrowserRouter data-id="element-0">
      <ScrollToTop data-id="element-1" />
      <AnnouncementBanner data-id="element-2" />
      <Routes data-id="element-3">
        <Route path="/" element={<LandingPage data-id="element-5" />} data-id="element-4" />
        <Route path="/context-engineering" element={<ContextEngineeringPage data-id="element-7" />} data-id="element-6" />
        <Route path="/how-it-works" element={<HowItWorksPage data-id="element-9" />} data-id="element-8" />
        <Route path="/the-instruction-layer" element={<ArchitecturePage data-id="element-11" />} data-id="element-10" />
        <Route path="/about" element={<AboutPage data-id="element-13" />} data-id="element-12" />
        <Route path="/pricing" element={<PricingPage data-id="element-15" />} data-id="element-14" />
        <Route path="/blog" element={<BlogPage data-id="element-17" />} data-id="element-16" />
        <Route path="/blog/:slug" element={<BlogArticleDetail data-id="element-19" />} data-id="element-18" />
        <Route path="/contact" element={<ContactPage data-id="element-21" />} data-id="element-20" />
        <Route path="/privacy" element={<PrivacyPage data-id="element-23" />} data-id="element-22" />
        <Route path="/terms" element={<TermsPage data-id="element-25" />} data-id="element-24" />
        <Route path="/login" element={<LoginPage data-id="element-27" />} data-id="element-26" />
        <Route path="/agent-drift" element={<AgentDriftPage data-id="element-29" />} data-id="element-28" />
        <Route path="/support" element={<SupportPage data-id="element-31" />} data-id="element-30" />
      </Routes>
    </BrowserRouter>;
}